import React from 'react';
import { MdChevronRight } from 'react-icons/md';
import {
  Container, Distance, IconContainer, ImageButton, Info, InfoContainer, Medal, Title,
} from './styles';
import { formatDistances } from '../../utils';

interface Props {
  image: string,
  medal: string,
  medalBanner?: string,
  title: string,
  info: string,
  distances: number [],
  action: () => void,
}

export default function VirtualRaceCardList({
  image, medalBanner, medal, title, info, distances, action,
}: Props) {
  return (
    <Container onClick={action}>
      <ImageButton image={image}>
        <Medal src={medalBanner ?? medal} />
        <InfoContainer>
          <Title>
            {title}
          </Title>
          <Distance>
            {formatDistances(distances)}
          </Distance>
          <Info>
            {info}
          </Info>
        </InfoContainer>
        <IconContainer onClick={() => {}}>
          <MdChevronRight size={50} color="white" />
        </IconContainer>
      </ImageButton>
    </Container>
  );
}
